<!--
    @name   多选/全选
    @desc   最前面列操作-目前只添加多选
    @author linmn
    @date   2017.11.16
-->
<template lang="pug">
  //- 单个选择
  el-checkbox(
    v-if="isCheckItem"
    v-model="isCheck"
    :checked="Boolean(isCheck)"
    :true-label="checkBoxOptions.id"
    @change="handleCheckedItem(checkBoxOptions.id, isCheck)")
  //- 全选
  el-checkbox(
    ref="isCheckAll"
    v-else-if="isCheckAll"
    v-model="checkAll"
    :true-label="checkBoxOptions.id"
    :indeterminate="indeterminate"
    @change="handleCheckedAll(checkAll)")
</template>

<script>
export default {
  name: 'VCheckBox',
  props: {
    checked: Boolean,
    isCheckItem: Boolean,
    isCheckAll: Boolean, // 设置是否为全选
    checkBoxOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    checkGroupValue: {
      type: Array,
      default: () => []
    },
    indeterminate: Boolean
  },
  data () {
    return {
      isCheck: false,
      checkAll: false
    }
  },
  watch: {
    checked (value) {
      // 监听父选框对子选项的影响
      this.isCheck = value
    },
    checkGroupValue (arr) {
      // 监听选项值对父选框操作
      this.checkAll = arr.length !== 0
    }
  },
  methods: {
    handleCheckedItem (value, check) {
      const checked = Boolean(this.isCheck)
      this.$emit('checkValue', value, checked)
    },
    handleCheckedAll (value) {
      this.isCheck = false
      this.$emit('isCheckItem', true)
      this.$emit('checkValue', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// VCheckBox.vue?4135d59d